import * as React from 'react';

function SvgPie(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 28 29" width="1em" {...props}>
      <defs>
        {/* <style>.cls-1{fill:none;}.cls-2{opacity:0.5;isolation:isolate;}.cls-3{fill:#d4af37;}.cls-4{clip - path:url(#clip-path);}.cls-5{fill:#fff;}.cls-6{clip - path:url(#clip-path-2);}.cls-7{clip - path:url(#clip-path-3);}.cls-8{clip - path:url(#clip-path-4);}</style> */}
        <clipPath id="clip-path">
          <path
            d="M14,22.64a7.72,7.72,0,1,0-7.72-7.72h0A7.72,7.72,0,0,0,14,22.64Zm0,1.28a9,9,0,1,1,9-9,9,9,0,0,1-9,9Z"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <path
            d="M17,19.67a.25.25,0,0,0,.18-.1.31.31,0,0,0,.06-.19l-.36-3.07L19,14a.26.26,0,0,0,.06-.25.28.28,0,0,0-.2-.18l-3-.61L14.31,10.3a.25.25,0,0,0-.34-.1.24.24,0,0,0-.1.1L12.25,13l-3,.61a.28.28,0,0,0-.2.18.26.26,0,0,0,.06.25l2.1,2.28-.36,3.07a.26.26,0,0,0,.23.28.22.22,0,0,0,.14,0L14,18.36l2.82,1.29A.32.32,0,0,0,17,19.67Z"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-3">
          <rect fill="none" height="20" width="20" x="4" y="5.17" />
        </clipPath>
        <clipPath id="clip-path-4">
          <rect fill="none" height="10" width="12" x="8" y="10.17" />
        </clipPath>
      </defs>
      <image
        height="29"
        style={{ opacity: 0.5, isolation: 'isolate' }}
        width="28"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAeCAYAAADQBxWhAAAACXBIWXMAAAsSAAALEgHS3X78AAAEVklEQVRIS72WTU8bVxSGn/eOZxjjkKJYA0kDSqpSqcK7VJEqVaqSdsc+/B3bfyfZZ5susotCF5WtSkWFKOQDpkQIw3jwxz1deDAfpUkMUt6V5Tn3PPfec8+HzIwvLfcpg4skSYCKn/qU/XlpkpNK0qNHj9zNmzdL5XI5Auh2u733798Pnjx54u0znX0SKkmNRkOtVku1Wi1M07QSBMGNUqlUBRgMBrvD4fBDkiSHrVarX6vVrNFo2Mc28FFos9l0u7u74fT0dJzneTw1NTXrvV80syUz+wZA0oakdefc66Ojo704jvMsy/Jqtdqv1+v+Ir//C11dXQ2SJClPT08nZnYbmDOzBeB7YAm4VZi+A9aBPyVtATuS3mRZlqZp2n38+PHwvO8Loaurq0GtVit3Op0F7/09ST8AdyQl3vtbwA1J0wBmlgEfnHPvzCwFXpnZSzP7PYqirY2Njex8vP8DPQbu7e0tOufuAw/N7J6kOaAMxECJk5fvgQGQA10z25G0Juk37/1aHMdvDw4ODk5fd+k0sNlsuiRJyp1OZ6EA/grcl7RQAB1FqpxaFhT/h0BFUgUIzSwCZvI8/6NcLv8F/COpb2Y2zlNJKh5N4r2/BzwE7pvZIlDh5HQX5aWKb6XCdhH4EViR9LP3fnF3dzc+vtWg0WiMVklOUmUwGHwn6Rcz+0nSnWLnkxQRMYKXgbKkQ0l/l8vld8+fP88fPHhwctLl5WXleR4XsbtzKoaTAI/lgClJ1yR95b2/1u12o+XlZR1/RJKePn0aArOSvgYSLg8EwMwERN77WWDezK632+1QklxhwN27d6MoiubMbEnSvKQpLo7fZ0kSkiLn3BzwbRRFc0BkZqOTNJtNpWkamtl1il1570OuAAXkvT/jM03TsNlsanx9cRzLzEIgAkJp8u5xXoWPkNEJwziOT2L6pTWG5nlukvpAD+ifLluXVeGjD/Qk9fM8Nyig9XrdkiTpS9oHtiXtO+f6wFXA5pw74zNJkn69XrfjlGFzc7PX6/V2JK2b2baZHXFFqJkdmdm2pPVer7ezubnZk8RxytjKykof2DOzt0AKdBkV88vKM/KRFj73VlZWztbedrttcRznZrbDqD3tcHmwp+g4FL7iOM7b7fZJTAEajYZlWZYHQbBlZi8lrQFbNuqXk4B9sWZL0pqZvQyCYCvLsrzRaJyFmplVq9V+lmWpc24NeAa8kPQaOGTUMz0Xx9k46auHxZoXwDPn3FqWZWm1Wh1nxMRNXNKU935cPMzMnHP94uGNmzjwzHv/YnZ29nWr1Toztkw0rgCJpHkblbawMO9L2jezbUYP8JWZvXTOrc3MzGydB8KEgxlw28yWgHlgqjA9YpSH68AbLjuYHev8CArMOufmgiC4PhwOSwBBEAyGw+G+934HuNoIOjbQybBdqVTCmZmZyHs/Lt55nptzrt/pdHqHh4dXH7bPS5LMjGazeaYD1et1k8THQKf1L+QwtRuQGGuFAAAAAElFTkSuQmCC"
      />
      <path
        d="M24.7,13.83c-.81-1.46-1-1.59-1-2V10.5c0-1.73-1.74-2.14-2.35-2.62-.32-.19-.29-.35-1-1.57-.89-1.48-2.57-1-3.25-1.07-.38,0-.5-.2-2-1-1.87-1.07-3.16,1-4.14,1H9.58C7.86,5.24,7.44,7,7,7.58c-.17.3-.38.32-1.58,1.06-1.51.9-1,2.61-1.07,3.24,0,.91-2.06,2.36-1,4.14,1.44,2.57.88,1,1,3.33,0,2,2.28,2.22,2.64,2.91s.88,2.35,2.62,2.35c1.28,0,1.45-.08,1.8.11,1.4.78,1.64,1.09,2.31,1.17,1.08.14,1.44-.33,3-1.17.33-.19.49-.08,1.81-.11,2,0,2.18-2.24,2.9-2.64s2.35-.89,2.35-2.62c0-1.3-.07-1.46.11-1.79l.9-1.54A2.15,2.15,0,0,0,24.7,13.83Z"
        fill="#d4af37"
      />
      <g className="cls-4" clipPath="url(#clip-path)">
        <rect className="cls-5" fill="#fff" height="28" width="28" y="0.92" />
      </g>
      <g className="cls-6" clipPath="url(#clip-path-2)">
        <g className="cls-7" clipPath="url(#clip-path-3)">
          <g className="cls-8" clipPath="url(#clip-path-4)">
            <rect className="cls-5" fill="#fff" height="19.5" width="20" x="4" y="5.17" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgPie;
